// extracted by mini-css-extract-plugin
export default {"steps":"StepsProgress_steps__IfeWk","step":"StepsProgress_step__RgLMP","small":"StepsProgress_small__GAc6R","active":"StepsProgress_active__XQsSS"};